module.exports = __webpack_public_path__ + "ad012c0bcb61d4c2a5d2583938e8e3e9.png";